export const iconFontAwesomeEnergyPowerOff = (
	<i className="fa-solid fa-power-off"></i>
);
